"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hexToRgb = void 0;
var numeric_1 = require("../../../functions/numeric");
var clamp255 = (0, numeric_1.clamp)(0, 255);
var parseAsHexAndClamp = function (hexStr) {
    return clamp255(parseInt(hexStr, 16));
};
var hexToRgb = function (hex) {
    if (!/^#[0-9a-fA-F]{6}$/.test(hex))
        return [0, 0, 0];
    var r = parseAsHexAndClamp(hex.slice(1, 3));
    var g = parseAsHexAndClamp(hex.slice(3, 5));
    var b = parseAsHexAndClamp(hex.slice(5, 7));
    return [r, g, b];
};
exports.hexToRgb = hexToRgb;
